import React, {useState} from "react";
import {adminGetDashboardVendors} from "../../../services/api/admin";
import ConfirmationModal from "../../Modal/ConfirmationModal";
import {Button, TextInput} from "flowbite-react";
import {Search} from "react-feather";

const SearchAndUpdateVendorFlagBlock = ({handleFlagUpdate}) => {

    const [searchedVendors, setSearchedVendors] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [isSearchVendorLoaded, setIsSearchVendorLoaded] = useState(true);
    const [selectedVendor, setSelectedVendor] = useState(null);

    const searchVendorsByTerm = async () => {
        try {
            if (searchTerm.length === 0) {
                setSearchedVendors([]);
                return;
            }
            setIsSearchVendorLoaded(false)
            setSearchedVendors([]);
            const {data} = await adminGetDashboardVendors({
                term: searchTerm,
                page: 1,
                per_page: 10,
                has_dashboard: 0
            });
            setIsSearchVendorLoaded(true);
            setSearchedVendors(data);
        } catch (e) {
            setIsSearchVendorLoaded(true);
            console.error('Error fetching vendors:', e);
        }
    }

    const handleConfirm = async () => {
        try {
            await handleFlagUpdate(selectedVendor.id, true);
            setSelectedVendor(null);
            setSearchTerm('');
        } catch (e) {
            setSelectedVendor(null);
            setSearchTerm('');
        }
    }

    React.useEffect(() => {
            searchVendorsByTerm().then(r => console.log('r', r));
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [searchTerm])

    return <div className={"sl-flex sl-flex-row sl-justify-center"}>

        {selectedVendor && <ConfirmationModal
            title={`Add Dashboard feature for : ${selectedVendor.name}`}
            message={`Are you sure you want to add Dashboard feature to this Vendor?`}
            handleConfirm={handleConfirm}
            handleClose={() => {
                setSelectedVendor(null);
            }}
        />}

        <div
            className={"sl-border-1 sl-bg-gray-200 sl-border-solid sl-border-radius-8 sl-border-gray-200 sl-p-4 sl-mb-4 sl-flex sl-flex-col sl-w-120"}>
            <span className={"sl-text-md sl-p-2"}>Add Dashboard to a Vendor</span>
            <div className={"sl-flex sl-flex-row relative"}>

                <TextInput
                    value={searchTerm}
                    onChange={(e) => {
                        setSearchTerm(e.target.value)
                    }}
                    isProcessing={isSearchVendorLoaded}
                    className={"sl-w-92"}
                    type="text" sizing="md" placeholder={'Enter Vendor name'}/>

                {searchedVendors.length > 0 && <div
                    className={"sl-absolute sl-bg-white sl-top-12 sl-border-radius-8 sl-z-10 sl-shadow-sm sl-w-fill-available "}>
                    <div className={"sl-flex sl-flex-col"}>
                        {searchedVendors.map((vendor) => (
                            <div
                                onClick={() => setSelectedVendor(vendor)}
                                className={"sl-hover-gray-50 sl-cursor-pointer sl-p-2 sl-border-b-1 sl-border-solid sl-border-gray-200"}>
                                {vendor.name}
                            </div>))}
                    </div>
                </div>}

                <div style={{width: '30px', marginLeft: '10px'}}>
                    <Button size="md" isProcessing={!isSearchVendorLoaded} onClick={searchVendorsByTerm}
                            className={"sl-h-10"}
                            color={"light"}>
                        {isSearchVendorLoaded && <Search size={16}/>}
                    </Button>
                </div>
            </div>
        </div>
    </div>

}

export default SearchAndUpdateVendorFlagBlock;